// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3fvK4","header":"Messages_header__yorXX"};